import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { IdsButton, IdsCheckbox } from '@investec/ids-web-react';
import { useUnifiedAnalytics } from '../../../../contexts/AnalyticsWrapper';
import './IsaTransferInstructionsModal.scss';

const IsaTransferInstructionsModal = ({ isOpen, onClose, onReturnToDashboard, isDisaTransfer = false }) => {
    const [acknowledged, setAcknowledged] = useState(false);
    const analytics = useUnifiedAnalytics();
    const navigate = useNavigate();

    const trackEvent = (name, action, label) => {
        if (analytics) {
            analytics.trackAnalyticsClickEvent(
                name,
                window.location.href,
                isDisaTransfer ? 'disa-transfer-modal' : 'fisa-transfer-modal',
                isDisaTransfer ? 'disa' : 'fisa_1yr',
                '',
                {},
                action,
                label,
                isDisaTransfer ? 'account_closure' : 'account_closure_penalty'
            );
        }
    };

    useEffect(() => {
        if (isOpen) {
            setAcknowledged(false);
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="disa-transfer-modal" role="dialog" aria-modal="true" aria-labelledby="disa-transfer-modal-title">
            <section className="disa-transfer-modal__content">
                <button
                    className="disa-transfer-modal__close"
                    type="button"
                    onClick={() => {
                        trackEvent(
                            isDisaTransfer ? 'disa transfer instructions modal close' : 'fisa transfer instructions modal close',
                            'button click',
                            isDisaTransfer ? 'close_disa_account|button_click|transfer_modal_close' : 'close_fisa_account|button_click|transfer_modal_close'
                        );
                        onClose();
                    }}
                    aria-label="Close transfer instructions"
                >x</button>
                <h2 id="disa-transfer-modal-title">Transferring your ISA to another provider</h2>
                <p>We support full transfers to all ISA providers.</p>
                {isDisaTransfer && (
                    <p>Your full balance will be transferred to your new provider and your Instant Access Cash ISA will close. You won&apos;t be able to open another Instant Access Cash ISA, as this account is only available when a Fixed Rate Cash ISA reaches maturity.</p>
                )}
                <p>We primarily support digital transfers, however we can arrange manual transfers if your new provider does not accept transfers digitally.</p>

                <ol className="disa-transfer-modal__timeline">
                    <li>
                        <h3>Ask your new provider to arrange a transfer</h3>
                        <p>To keep your ISA&apos;s tax-free status, your new provider must request the transfer on your behalf.</p>
                        <aside>
                            <span aria-hidden="true">i</span>
                            <p>If you close your account or move the money yourself, you&apos;ll lose your ISA&apos;s tax-free status.</p>
                        </aside>
                    </li>
                    <li>
                        <h3>We will receive the transfer request</h3>
                        <p>Once we receive a valid transfer request from your new provider, we&apos;ll begin your transfer.</p>
                    </li>
                    <li>
                        <h3>Your transfer begins</h3>
                        <p>Cash ISA transfers usually take up to 15 business days.</p>
                    </li>
                </ol>

                <div className="disa-transfer-modal__acknowledgement">
                    <IdsCheckbox
                        checked={acknowledged}
                        onChange={event => {
                            const checked = event.target.checked;
                            trackEvent(
                                isDisaTransfer ? `disa transfer instructions acknowledgment ${checked ? 'checked' : 'unchecked'}` : `fisa transfer instructions acknowledgment ${checked ? 'checked' : 'unchecked'}`,
                                'checkbox click',
                                isDisaTransfer
                                    ? `close_disa_account|checkbox_click|transfer_acknowledgment_${checked ? 'checked' : 'unchecked'}`
                                    : `close_fisa_account|checkbox_click|transfer_acknowledgment_${checked ? 'checked' : 'unchecked'}`
                            );
                            setAcknowledged(checked);
                        }}
                    >
                        I understand that I need to ask my new provider to arrange the transfer for me.
                    </IdsCheckbox>
                </div>
                <footer>
                    <IdsButton
                        appearance="primary"
                        size="md"
                        disabled={!acknowledged}
                        onClick={() => {
                            trackEvent(
                                isDisaTransfer ? 'disa transfer instructions modal return to dashboard' : 'fisa transfer instructions modal ok go to dashboard',
                                'button click',
                                isDisaTransfer ? 'close_disa_account|button_click|transfer_modal_return_to_dashboard' : 'close_fisa_account|button_click|transfer_modal_ok'
                            );
                            if (isDisaTransfer) {
                                onReturnToDashboard();
                            } else {
                                onReturnToDashboard();
                                navigate('/');
                            }
                        }}
                    >
                        Return to your dashboard
                    </IdsButton>
                </footer>
            </section>
        </div>
    );
};

export default IsaTransferInstructionsModal;
